import { Calendar } from 'fullcalendar'

window.initCalendar = function(){
  const calendarEl = document.getElementById('calendar');

  const calendar = new Calendar(calendarEl, {
    initialView: window.innerWidth < 900 ? 'listMonth' : 'dayGridMonth',
    firstDay: 1,
    contentHeight: 'auto',
    displayEventTime: false,
    // switch to list view when in mobile mode
    windowResize: function() {
      const currentView = calendar.view.type;
      if (window.innerWidth < 900) {
        if (currentView !== 'listMonth') calendar.changeView('listMonth');
      } else {
        if (currentView !== 'dayGridMonth') calendar.changeView('dayGridMonth');
      }
    },
    loading: function(bool) {
      calendarEl.classList.toggle('is-loading', bool);
    },
    datesSet: function(info) {
      const start = info.startStr;
      const end = info.endStr;

      calendarEl.classList.add('is-loading');

      $.ajax({
        url: '/admin/overview/calendar',
        method: 'GET',
        dataType: "json",
        data: {
          for_clients: $('[name="for_clients"]:checked').val(),
          admin_id: $('[name="admin_id"]').val(),
          start: start,
          end: end
        },
        success: function(response) {
          const events = parseResponse(response);
          calendar.removeAllEvents();
          calendar.addEventSource(events);
          calendar.render();
          calendarEl.classList.remove('is-loading');
        },
        error: function(error) {
          console.error('Error fetching data:', error);
          calendarEl.classList.remove('is-loading');
        }
      });
    },
    eventContent: function(arg) {
      // TRIAL MARK HERE
      return {
        html: `
          <div class="calendar-event-content ${arg.event.extendedProps.statusClass} is-trial--${arg.event.extendedProps.onTrial}">
            <div class="event-title">
              ${arg.event.title} ${ arg.event.extendedProps.onTrial ? `<mark class='tag is-trial ${ arg.event.extendedProps.finishedTrial ? 'is-completed' : '' } is-round is-extra-small' data-controller='tooltip' data-tooltip='${I18n.t('assessment.trial_assessment')}'>T</mark>` : "" }
              ${ renderSharedStatus(arg.event.extendedProps.sharedWithClient) }
            </div>
          </div>
        `
      };
    },
    eventClick: function(info) {
      const event = info.event;
      $.ajax({
        method: "GET",
        url: `/admin/assessments/${event.id}`,
        dataType: "script"
      })
    }
  })
  calendar.render()
}

function renderSharedStatus(status) {
  if(!status) return ''
  if(status == 'shared') return `<mark class='tag is-round is-extra-small is-shared' data-controller='tooltip' data-tooltip='${I18n.t(`assessment.shared_with_client_statuses.${status}`)}'>S</mark>`
  return `<mark class='tag is-round is-extra-small is-not-shared' data-controller='tooltip' data-tooltip='${I18n.t(`assessment.shared_with_client_statuses.${status}`)}'>S</mark>`
}

function parseResponse(response) {
  const events = [];
  
  response.forEach(item => {
    const event = {
      id:               item.id,
      backgroundColor:  item.backgroundColor,
      borderColor:      item.borderColor,
      textColor:        item.textColor,
      title:            item.title,
      start:            item.start,
      extendedProps: {
        subtitle:         item.subtitle,
        statusClass:      item.statusClass,
        onTrial:          item.onTrial,
        finishedTrial:    item.finishedTrial,
        sharedWithClient: item.sharedWithClient
      }
    };
    
    events.push(event);
  });
  
  return events;
}

